// src/components/Dashboard/StatusBadge.jsx
//
// Etiqueta de color con el estado de Organized de un reclamo (oaStatus). Si el
// estado no está en el catálogo se muestra neutro, con su nombre tal cual.
import React from 'react';
import { findStatus, contrastText } from '../../config/claimStatuses';

const StatusBadge = ({ name, catalog }) => {
  if (!name) return null;
  const status = findStatus(catalog, name);
  const style = status ? { background: status.color, color: contrastText(status.color) } : undefined;
  return <span className={`status-badge ${status ? '' : 'is-neutral'}`} style={style}>{status?.name || name}</span>;
};

export default StatusBadge;
